module.exports = __webpack_public_path__ + "static/media/welcome.beb53d91.wav";